let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("Lxk9J")).then(() => parcelRequire('9avVd'));